import { connect } from 'react-redux';
import TextWhatifView from '../../../TextWhatif/TextWhatIfView';
import { goalId as selectedGoalId } from '../../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../../WhatIfsRouteDictionary';

import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
} from '../../../WhatIfsActions';

import {
  loading,
  nullableFpIdSelector,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
} from '../../../WhatIfsSelector';

import insuranceValue from './HomeInsuranceSelector';

const mapStateToProps = (state, ownProps) => ({
  value: insuranceValue(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  loading: loading(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  label: 'Home Insurance',
  id: 'HomeInsurance',
  valueStorePath: 'WhatIf.HomeInsurancePerYear',
  hasCurrency: true,
  hasPerYear: true,
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(planImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(initialPlanImpact(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(applyWhatIf(
      clientId,
      fpId,
      goalId,
      whatIf,
      RouteDictionary[whatIfTemplate.WhatIfType],
      Object.keys(whatIfTemplate),
      whatIfTemplate.WhatIfType,
    ));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TextWhatifView);
